import React, { useMemo, useState } from 'react'

import { LoggedOutBoxSummaryModal } from '@features/box-summary'
import type { RecipeUUID } from '@library/menu-service'

import { RecipeDetail } from '../Search/RecipeDetail/RecipeDetail'
import type { BoxSummaryTreatmentProps } from './props'
import { useLoggedOutBoxSummaryController } from './useLoggedOutBoxSummaryController'

const BoxSummaryTreatmentContent = (props: BoxSummaryTreatmentProps) => {
  const controller = useLoggedOutBoxSummaryController(props)
  const [selectedRecipeId, setSelectedRecipeId] = useState<string | null>(null)

  // Override onSummaryRecipeClick to show recipe detail inline inside the
  // modal (matching the ViewBasketModal pattern) rather than dispatching the
  // Redux menuRecipeDetailVisibilityChange action, which opens a separate
  // portal modal that can end up behind the treatment modal.
  const patchedController = useMemo(
    () => ({
      ...controller,
      actions: {
        ...controller.actions,
        onSummaryRecipeClick: (recipeId: string) => setSelectedRecipeId(recipeId),
      },
    }),
    [controller],
  )

  const recipeDetail =
    selectedRecipeId != null ? (
      <RecipeDetail
        recipeId={selectedRecipeId as RecipeUUID}
        onClose={() => setSelectedRecipeId(null)}
        onSelectRecipe={(recipeId) => setSelectedRecipeId(recipeId)}
      />
    ) : undefined

  return <LoggedOutBoxSummaryModal controller={patchedController} recipeDetail={recipeDetail} />
}

export const BoxSummaryTreatment = (props: BoxSummaryTreatmentProps) => {
  const { showDetails } = props

  // The modal renders nothing while closed, so only mount the controller-bearing
  // content when the box summary is shown. This keeps the (selector-heavy)
  // useLoggedOutBoxSummaryController hook off the menu's re-render hot path.
  if (!showDetails) {
    return null
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <BoxSummaryTreatmentContent {...props} />
}
